import React, { useContext, useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
import { Avatar } from '../common/Avatar';
import ComponentContainer from '../common/ComponentContainer';
import { ViewMore } from '../common/ViewMore';
import { H1, H4, H6 } from '../text';
import LayoutContext from '../../contexts/Layout';
import Utils from '../../common/Utils';

export const ListItem = ({ description, followContentLink, heading, image, layout, link, nodeTypeAlias = 'ListItem', renderBorder = false }) => {
    return (
        <Pressable
            onPress={async () => {
                if (link?.internalKey?.length > 0 && followContentLink) {
                    await followContentLink(undefined, link.internalKey);
                }
            }}
        >
            <View
                dataSet={{ umbracoComponentName: nodeTypeAlias }}
                style={StyleSheet.flatten(renderBorder ? { borderBottomColor: '#dde4e9', borderBottomWidth: 1 } : undefined, {
                    alignItems: 'center',
                    flexDirection: layout.device.isMobile ? 'column' : 'row',
                    marginVertical: layout.styleGuide.spacer2
                })}
            >
                <Avatar imageUri={image.cdnImagePath} size={layout.device.isMobile ? 60 : 96} style={{ alignSelf: 'flex-start' }} />

                <View style={{ justifyContent: 'flex-end', marginHorizontal: layout.styleGuide.spacer8, marginVertical: layout.styleGuide.spacer2, width: '90%' }}>
                    <H4 text={heading} style={{ marginBottom: layout.styleGuide.spacer3 }} />
                    <H6 numberOfLines={20} style={StyleSheet.flatten(Styles.itemDescription, { marginTop: layout.styleGuide.spacer3 })} text={description} />
                </View>
            </View>
        </Pressable>
    );
};

const ListItemContainer = ({ contentItems, followContentLink, heading, nodeTypeAlias = 'ListItemContainer' }) => {
    const { layout } = useContext(LayoutContext);
    const [viewMoreIsOpen, setViewMoreIsOpen] = useState(false);
    const listItems = Object.values(contentItems);

    const renderListItems = () => {
        let itemsToRender = [];

        listItems.forEach((item, idx) => {
            if (idx > 2 && !viewMoreIsOpen) {
                return null;
            }

            const { key, rest } = Utils.splitKeyFromProps(item);

            itemsToRender.push(<ListItem {...rest} key={key} followContentLink={followContentLink} layout={layout} renderBorder={true} />);
        });

        return itemsToRender;
    };

    return (
        <ComponentContainer dataSet={{ umbracoComponentName: nodeTypeAlias }} style={{ marginBottom: 0, marginTop: 0 }}>
            <H1 text={heading} style={{ marginBottom: layout.styleGuide.spacer3 }} />

            {renderListItems()}

            {listItems?.length > 3 && (
                <View style={{ flexDirection: 'row', justifyContent: 'center', marginVertical: layout.styleGuide.spacer2 }}>
                    <ViewMore handler={() => setViewMoreIsOpen(!viewMoreIsOpen)} text={viewMoreIsOpen ? 'less' : 'more'} />
                </View>
            )}
        </ComponentContainer>
    );
};

const Styles = StyleSheet.create({
    itemDescription: {
        marginTop: 0,
        marginHorizontal: 0,
        fontFamily: 'GothamBook'
    }
});

ListItem.propTypes = {
    followContentLink: PropTypes.func,
    image: PropTypes.object,
    heading: PropTypes.string,
    iconClass: PropTypes.string,
    description: PropTypes.string
};

ListItemContainer.propTypes = {
    heading: PropTypes.string,
    contentItems: PropTypes.object,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default ListItemContainer;
